import { type ComponentProps } from 'react';
import { type MainTabBarItem } from '@sg/garnish';

import { useFeatureFlag } from '@order/LaunchDarkly';

import { type MainTabName } from '../../AppNavigation.props';

export function useTabBarIcons(): TabBarIconConfig {
  const isBottomTabsIconsEnabled = useFeatureFlag(
    'CELS-1430-bottom-tabs-icons-enabled',
  );

  return isBottomTabsIconsEnabled
    ? TAB_BAR_WITH_ICONS_CONFIG
    : TAB_BAR_WITHOUT_ICONS_CONFIG;
}

// ─── Constants ───────────────────────────────────────────────────────────────

const TAB_BAR_WITH_ICONS_CONFIG: TabBarIconConfig = {
  HomeTab: {
    iconName: 'IconHomeAlternative',
  },
  MenuTab: {
    iconName: 'IconMenuBowl',
  },
  LoyaltyTab: {
    iconName: 'IconLoyaltyCoupon',
  },
  ScanTab: {
    iconName: 'IconScan',
  },
  AccountTab: {
    iconName: 'IconAccount',
  },
};

const TAB_BAR_WITHOUT_ICONS_CONFIG: TabBarIconConfig = {
  HomeTab: null,
  MenuTab: null,
  LoyaltyTab: null,
  ScanTab: null,
  AccountTab: null,
};

// ─── Types ───────────────────────────────────────────────────────────────────

type TabIconConfig = Pick<ComponentProps<typeof MainTabBarItem>, 'iconName'>;

type TabBarIconConfig = Record<MainTabName, TabIconConfig | null>;
